/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PricedStatus {
    ALL = 'all',
    PRICED = 'priced',
    NO_CUTS = 'noCuts',
    UNPRICED = 'unpriced',
}
